/**
 * English for the operations screens (card У8): «Сегодня», Журнал, «Здоровье
 * данных», Источники, Домены, Настройки — Общие, Цели, Оповещения. Spread
 * into `en`, so `ru.ops.ts` must cover every key.
 */
export const enOps = {
  "ops.open": "Open",
  "ops.cancel": "Cancel",
  "ops.refresh": "Refresh",
  "ops.more": "More",
  "ops.yes": "Yes",
  "ops.foot.spend": "Facebook spend {age} ago",
  "ops.today.day": "day in {tz}",
  "ops.today.stale": "not refreshed — showing the last numbers",
  "ops.today.wasAt": "yesterday by {at}: {value}",
  "ops.today.yesterday": "yesterday {value}",
  "ops.today.holdLeads": "{leads} leads × approval {rate}",
  "ops.today.chart.was": "yesterday {value}",
  "ops.today.chart.end": "yesterday's total {value}",
  "ops.today.allCampaigns": "All campaigns",
  "ops.today.byProfit": "by profit",
  "ops.today.best.empty": "Nobody is in profit yet today",
  "ops.today.worst.empty": "Nobody is losing today",
  "ops.today.att.losing": "ROI {roi} today on {cost} spend · approval {ar}",
  "ops.today.att.noClicks": "No clicks today while spend runs: {cost}",
  "ops.first.subtitle": "No campaigns yet — a domain, what a campaign is made of, then the campaign",
  "ops.first.waiting": "appears after the first clicks",
  "ops.first.title": "Ready for the first campaign",
  "ops.first.progress": "{done} of {total}",
  "ops.first.counted": "Have: {count}",
  "ops.first.network.done": "{name} is connected",
  "ops.first.network.todo": "The network takes the leads and sends postbacks",
  "ops.first.network.add": "Add a network",
  "ops.first.source": "Source",
  "ops.first.source.done": "{name}: click id {param}",
  "ops.first.source.todo": "Where the traffic is bought: Facebook, TikTok, Google",
  "ops.first.source.add": "Add a source",
  "ops.first.offer.todo": "Add the network's link and the payout — without it the tracker does not know where to send a person",
  "ops.first.offer.add": "Add an offer",
  "ops.first.lander.todo": "Upload a ZIP or give the address of the page a person sees before the offer",
  "ops.first.lander.add": "Add a lander",
  "ops.first.road": "How a person goes",
  "ops.first.road.ad": "Ad",
  "ops.first.road.domain": "Your domain",
  "ops.first.road.lander": "Lander",
  "ops.first.road.offer": "Offer",
  "ops.first.road.network": "Network",
  "ops.first.road.body": "A person clicks the ad and lands on your domain. The tracker records the click, shows the lander and sends the person to the network's offer. When the network sends a postback, the click becomes a lead, then an approval.",
  "ops.first.spend": "Spend arrives by itself",
  "ops.first.spend.body": "For Facebook campaigns spend comes from the ad accounts through vibe-fb every 15 minutes.",
  "ops.health.subtitle": "Everything that can make the report numbers disagree with the truth",
  "ops.health.checkNow": "Check now",
  "ops.health.k.problems": "Problems",
  "ops.health.k.problems.note": "break the numbers",
  "ops.health.k.warnings": "Warnings",
  "ops.health.k.warnings.note": "may break them",
  "ops.health.k.ok": "In order",
  "ops.health.k.ok.note": "checks of {total}",
  "ops.health.k.last": "Last check",
  "ops.health.k.last.note": "every minute",
  "ops.health.sortOut": "To sort out",
  "ops.health.sortOut.note": "what breaks money first",
  "ops.health.breaks": "What it breaks",
  "ops.health.fine": "In order",
  "ops.health.fold": "Fold",
  "ops.health.unfold": "Unfold",
  "ops.health.ago": "{age} ago",
  "ops.health.since": "since {at}",
  "ops.health.empty": "empty",
  "ops.health.clicks": "Clicks are written",
  "ops.health.clicks.ok": "lag {lag}, queue empty",
  "ops.health.clicks.last": "last click {age} ago",
  "ops.health.clicks.none": "no click in a day",
  "ops.health.clicks.noneShort": "none in a day",
  "ops.health.clicks.breaks": "No clicks for a while: a domain does not answer, campaigns are paused, or traffic goes around the tracker.",
  "ops.health.toDomains": "To domains",
  "ops.health.postbacks": "Postbacks are accepted",
  "ops.health.postbacks.ok": "{count} in a day, {share} matched",
  "ops.health.postbacks.none": "no postbacks in a day",
  "ops.health.rates": "Currency rates",
  "ops.health.rates.ok": "refreshed {at}, currencies: {count}",
  "ops.health.rates.never": "never loaded",
  "ops.health.fx": "Conversions without a rate",
  "ops.health.fx.ok": "0 in a day",
  "ops.health.fx.breaks": "Payouts in {codes} are not in revenue until there is a rate.",
  "ops.health.dlq": "Dead-letter queue (DLQ)",
  "ops.health.stuck": "Stuck events",
  "ops.health.stuck.ok": "0 older than 5 min",
  "ops.health.reports": "Reports",
  "ops.health.reports.ok": "behind the clicks by {age}",
  "ops.health.spend": "Facebook spend",
  "ops.health.spend.ok": "{age} ago, ads in a day: {ads}",
  "ops.health.spend.none": "vibe-fb has not sent spend yet",
  "ops.health.spend.breaks": "Spend from the ad accounts has not arrived for a while: profit and ROI of Facebook campaigns are too high.",
  "ops.health.toSources": "To sources",
  "ops.health.leads": "Leads delivered to networks",
  "ops.health.spendNoClicks": "Spend without clicks",
  "ops.health.spendNoClicks.ok": "all spend of 7 days has visits",
  "ops.health.spendNoClicks.badge": "{sum} USD in 7 days",
  "ops.health.showCampaigns": "Show campaigns",
  "ops.health.noClick": "Postbacks without a click",
  "ops.health.noClick.ok": "every postback found its click",
  "ops.health.noClick.breaks": "{networks} sends a click the tracker does not know. The leads are not in the reports until the click is found.",
  "ops.health.replay": "Replay {count}",
  "ops.health.unmapped": "Unknown network status",
  "ops.health.unmapped.ok": "every status is mapped",
  "ops.health.unmapped.breaks": "{list}. Such leads sit in hold — the approval rate is too low.",
  "ops.health.map": "Map the status",
  "ops.health.silent": "Networks send postbacks",
  "ops.health.silent.ok": "none silent past its limit",
  "ops.clicks.class.human": "People",
  "ops.clicks.class.all": "People and bots",
  "ops.clicks.city": "City",
  "ops.clicks.device": "Device · OS · browser",
  "ops.clicks.asn": "ASN",
  "ops.clicks.lander": "Lander",
  "ops.clicks.conv": "Conv.",
  "ops.clicks.leads": "{count} lead",
  "ops.clicks.search": "clickid, IP, sub1–sub20",
  "ops.bots.who": "Who was filtered out",
  "ops.bots.share": "{pct} of visits",
  "ops.bots.notClicks": "Bots are not clicks",
  "ops.bots.notClicks.body": "They are not in CR or EPC. The lander and offer they see follow the campaign flow's «bot» rule — usually a white page.",
  "ops.bots.hint.meta_crawler": "The platform checking the ad: Facebook ASN, facebookexternalhit",
  "ops.bots.hint.datacenter": "A hosting or cloud IP, not a home provider",
  "ops.bots.hint.listed_ip": "An IP from the shared bot list",
  "ops.bots.hint.crawler": "A search robot or scanner by its User-Agent",
  "ops.bots.hint.no_ua": "A request without a User-Agent — browsers do not do that",
  "ops.bots.hint.bot_score": "Behaviour: the bot score is over the threshold",
  "ops.bots.hint.verified_bot": "A verified robot: Google, Bing and the like",
  "ops.bots.why": "Why a bot",
  "ops.bots.why.listed": "IP in the bot list",
  "ops.bots.why.noUa": "no User-Agent",
  "ops.bots.why.score": "score {score}",
  "ops.bots.ip": "IP",
  "ops.pb.request": "In the request",
  "ops.src.subtitle": "Where traffic comes from. A source sets the tags a click carries and where the spend comes from",
  "ops.src.col.source": "Source",
  "ops.src.platform": "Platform",
  "ops.src.col.clickId": "Click id",
  "ops.src.col.campaigns": "Campaigns",
  "ops.src.col.way": "Spend comes",
  "ops.src.way.api": "From the API",
  "ops.src.way.apiAge": "From the API · {age} ago",
  "ops.src.way.late": "API is late",
  "ops.src.way.manual": "By hand",
  "ops.src.way.none": "Not connected",
  "ops.src.where": "Where the spend comes from",
  "ops.src.where.note": "no spend, no profit and ROI",
  "ops.src.where.fb": "{name} · vibe-fb",
  "ops.src.where.api": "Ads in a day: {ads}, synced every 15 minutes, last {age} ago",
  "ops.src.where.manual": "No API. Spend is entered in the campaign's settings or arrives with the click's tag",
  "ops.src.where.noSpend": "There are campaigns, no spend in the period",
  "ops.src.where.noCampaigns": "No campaigns",
  "ops.src.where.check": "Data health",
  "ops.src.where.connectApi": "Connect the API",
  "ops.src.where.connect": "Connect",
  "ops.src.newTitle": "New source",
  "ops.src.editTitle": "Source: {name}",
  "ops.src.used": "Used in {count} {campaigns} — changes apply to new clicks",
  "ops.src.unused": "Not used by any campaign yet",
  "ops.src.template": "Ad link template",
  "ops.src.template.hint": "Paste into the ad's «URL parameters». The campaign fills in the domain and path.",
  "ops.src.macros": "The platform's macros — click to insert",
  "ops.src.clickId": "Click id",
  "ops.src.fields": "What the click carries",
  "ops.src.add": "Add",
  "ops.src.col.param": "Parameter",
  "ops.src.col.what": "What it is",
  "ops.src.col.macro": "From the macro",
  "ops.src.col.example": "Example",
  "ops.src.example.hint": "From the source’s latest click in 7 days",
  "ops.src.own": "Your own tag",
  "ops.src.add.none": "Every platform parameter is in the link",
  "ops.src.aliases": "The same tags under other names",
  "ops.src.aliases.hint": "A link that arrives with utm_placement instead of sub4 is written into sub4. Works on domains laid over someone else’s site.",
  "ops.src.aliases.placeholder": "utm_placement=sub4",
  "ops.src.aliases.invalid": "Left — the tag’s name in Latin letters, right — sub1…sub20",
  "ops.src.what.campaignId": "Campaign ID",
  "ops.src.what.adSetId": "Ad set ID",
  "ops.src.what.adId": "Ad ID",
  "ops.src.what.placement": "Placement",
  "ops.src.what.campaignName": "Campaign name",
  "ops.src.what.adSetName": "Ad set name",
  "ops.src.what.adName": "Ad name",
  "ops.src.what.siteSource": "Where it was shown (fb, ig, an, msg)",
  "ops.src.what.adGroupId": "Ad group ID",
  "ops.src.what.adGroupName": "Ad group name",
  "ops.src.what.creativeId": "Ad (creative) ID",
  "ops.src.what.keyword": "Keyword",
  "ops.src.what.network": "Network (g, s, d)",
  "ops.src.what.device": "Device",
  "ops.src.what.clickId": "Click ID",
  "ops.src.remove": "Remove the parameter",
  "ops.src.spend": "Spend",
  "ops.src.spend.fb": "Spend comes from vibe-fb",
  "ops.src.spend.fb.last": "per ad, every 15 minutes · last {age} ago, ads in a day: {ads}",
  "ops.src.spend.fb.never": "per ad, every 15 minutes · not yet",
  "ops.src.costMacros": "Spend tags in the link",
  "ops.src.costMacros.hint": "When the platform puts the click's price in the link (spend, cpc) — comma-separated",
  "ops.src.capi": "vibe-fb sends conversions to Facebook",
  "ops.src.capi.body": "The tracker hands approvals to the Conversions API through the cabinet — no separate postback to the source is needed.",
  "ops.src.saved": "Source «{name}» saved",
  "ops.src.archive.title": "Archive «{name}»?",
  "ops.src.archive.body": "The source disappears from the choice in new campaigns.",
  "ops.src.archive.used": "{count} {campaigns} run on it: their clicks keep being recorded, new campaigns will not pick it.",
  "ops.src.archived": "«{name}» archived",
  "ops.dom.subtitle": "The address an ad link lives on. A person lands on it first, and only then on the lander and the offer",
  "ops.dom.connect": "Connect a domain",
  "ops.dom.usage": "Which domains",
  "ops.dom.usage.all": "All",
  "ops.dom.usage.busy": "In use",
  "ops.dom.usage.free": "Free",
  "ops.dom.usage.problems": "Problems",
  "ops.dom.search": "Search by address",
  "ops.dom.none": "No such domains",
  "ops.dom.col.campaigns": "Campaigns",
  "ops.dom.col.where": "Where",
  "ops.dom.col.checked": "Checked",
  "ops.dom.checkNow": "Check now",
  "ops.dom.unbind": "Unbind",
  "ops.dom.unbind.title": "Unbind {fqdn}?",
  "ops.dom.unbind.body": "The tracker stops answering on this domain. The domain itself stays with its provider.",
  "ops.dom.unbind.used": "{count} {campaigns} run on it: their links stop working. The domain itself stays with its provider.",
  "ops.dom.free": "Free",
  "ops.dom.fixAt": "Fix at the provider",
  "ops.dom.records": "DNS records",
  "ops.dom.checkedAt": "checked {at}",
  "ops.dom.proxied": "Proxied",
  "ops.dom.dnsOnly": "DNS only",
  "ops.dom.connection": "Connection",
  "ops.dom.where": "Where",
  "ops.dom.mode": "Mode",
  "ops.dom.mode.direct": "whole domain",
  "ops.dom.mode.overlay": "over a site",
  "ops.dom.ref": "Provider id",
  "ops.dom.added": "Added",
  "ops.dom.default": "Default",
  "ops.dom.default.yes": "yes — new campaigns take it",
  "ops.dom.default.no": "no",
  "ops.dom.campaigns": "Campaigns on the domain",
  "ops.dom.campaigns.none": "No campaign uses this domain",
  "entry.title": "Entry points",
  "entry.add": "Add entry point",
  "entry.none": "No entry points: each campaign serves at its own path. An entry point is one link per domain; a key in the link picks the campaign.",
  "entry.campaigns.count": "campaigns: {n}",
  "entry.new": "New entry point",
  "entry.create": "Create entry point",
  "entry.created": "Entry point created — publishing the domain",
  "entry.saved": "Entry point saved — publishing the domain",
  "entry.saveFailed": "Could not save the entry point",
  "entry.name.ph": "Main",
  "entry.path": "Path",
  "entry.selectors": "How the link names the campaign",
  "entry.byKey": "Key in the link — ?<token>",
  "entry.byParam": "Parameter value",
  "entry.byParam.hint": "Parameter name: ?c=<token>. Empty — not used",
  "entry.rules": "Rules (no token)",
  "entry.rules.hint": "When the link carries no token, the first matching rule hands the visit to its campaign.",
  "entry.rules.add": "Add rule",
  "entry.rule.field": "Field",
  "entry.rule.param": "Parameter",
  "entry.rule.op": "Condition",
  "entry.rule.values": "Values",
  "entry.rule.campaign": "Campaign",
  "entry.fallback": "When nothing matches",
  "entry.fallback.origin": "The domain's site (as is)",
  "entry.fallback.not_found": "404",
  "entry.fallback.redirect": "Redirect to a URL",
  "entry.fallback.campaign": "A default campaign",
  "entry.fallback.url": "URL",
  "entry.fallback.campaign.label": "Campaign",
  "entry.sticky": "Remember a returning visitor",
  "entry.sticky.off": "Don't",
  "entry.sticky.hour": "An hour",
  "entry.sticky.day": "A day",
  "entry.sticky.week": "A week",
  "entry.sticky.month": "30 days",
  "entry.active": "Entry point is on",
  "entry.active.hint": "An entry point turned off leaves the domain; campaigns with their own path keep serving",
  "entry.archive.title": "Archive entry point «{name}»?",
  "entry.archive.body": "Its path frees up and token links stop reaching the campaigns. Campaigns with their own path keep serving.",
  "entry.campaigns": "Campaigns behind it",
  "entry.campaigns.none": "None yet: add a campaign of this domain — it gets its own token and link.",
  "entry.campaigns.allBound": "Every campaign of the domain is already behind it",
  "entry.campaign.pick": "Campaign…",
  "entry.campaign.inactive": "not active — visits go to the fallback",
  "entry.unbind": "Remove from the entry point",
  "entry.bind": "Add",
  "entry.token": "Token",
  "entry.token.ph": "token (empty — a new UUID)",
  "entry.token.bad": "Letters, digits, _ . - (up to 100)",
  "ed.domain.entries": "Links through an entry point",
  "ed.domain.entries.pick": "Put behind an entry point…",
  "ops.dom.provider.manual": "Manual DNS",
  "ops.set.instant": "changes are saved at once",
  "ops.set.workspace": "Workspace",
  "ops.set.name.hint": "Shown on the rail and in exports",
  "ops.set.tz.hint": "Days in the reports, «Today» and offer caps are cut by it. Changing it recounts the reports",
  "ops.set.currency": "Report currency",
  "ops.set.currency.hint": "Payouts in other currencies convert at the ECB rate of the conversion's day",
  "ops.set.currency.usd": "USD — US dollar",
  "ops.goals.about": "A goal is what the network pays for. A postback brings the goal's key; revenue goals go to «Revenue», the primary one to «Leads» and CR.",
  "ops.goals.primary": "Primary",
  "ops.goals.editTitle": "Goal «{name}»",
  "ops.goals.key": "Key in the postback",
  "ops.al.new": "New alert",
  "ops.al.newTitle": "New alert",
  "ops.al.editTitle": "Alert: {name}",
  "ops.al.defaultName": "Campaigns are losing",
  "ops.al.empty": "No alerts yet",
  "ops.al.empty.body": "An alert watches a number — ROI, CPA, spend — and tells you when it crosses the line.",
  "ops.al.col.severity": "Severity",
  "ops.al.col.rule": "Rule",
  "ops.al.col.when": "When it fires",
  "ops.al.col.scope": "For what",
  "ops.al.col.last": "Fired",
  "ops.al.col.on": "On",
  "ops.al.scope": "Which campaigns",
  "ops.al.scope.all": "All campaigns together",
  "ops.al.scope.hint": "Without a campaign the alert watches the whole workspace's numbers",
  "ops.al.summary": "{cond} over {window}",
  "ops.al.window.hours": "{count} h",
  "ops.al.window.days": "{count} {days}",
  "ops.al.word.days": "day|days",
  "ops.al.window": "Over the window",
  "ops.al.window.last": "the last {window}",
  "ops.al.cooldown": "At most",
  "ops.al.cooldown.value": "once per {window}",
  "ops.al.when": "When",
  "ops.al.metric": "What",
  "ops.al.op": "Comparison",
  "ops.al.value": "Threshold",
  "ops.al.kind.roiBelow": "ROI",
  "ops.al.kind.cpaAbove": "CPA",
  "ops.al.kind.spendSpike": "Spend growth",
  "ops.al.kind.conversionDrop": "Approvals drop",
  "ops.al.kind.zeroConversions": "No approvals",
  "ops.al.zero.withClicks": "with clicks",
  "ops.al.hint.roiBelow": "ROI under the threshold while there is spend",
  "ops.al.hint.cpaAbove": "Spend per approval over the threshold; spend without approvals is «Critical» at once",
  "ops.al.hint.spendSpike": "Spend grew by more than the threshold against the previous window",
  "ops.al.hint.conversionDrop": "Fewer approvals than in the previous window, by more than the threshold",
  "ops.al.hint.zeroConversions": "Clicks, but no approvals",
  "ops.al.severity": "Severity",
  "ops.al.where": "Where to",
  "ops.al.where.tracker": "In the tracker — always: the firing history",
  "ops.al.where.owner": "To the alert's author — in his own notifications",
  "ops.al.dest.noHub": "The notification hub is not connected here — the alert still fires in the tracker.",
  "ops.al.dest.loading": "Loading the organisation's channels…",
  "ops.al.dest.loadFailed": "Could not load the organisation's channels — the alert keeps its choice.",
  "ops.al.dest.adminOnly": "The organisation's owner or admin picks its channels.",
  "ops.al.dest.picked": "Picked: {count}.",
  "ops.al.dest.empty": "The organisation has no channels yet — its admin connects them in the console, «Notifications».",
  "ops.al.dest.gone": "{count} picked channel(s) are no longer connected.",
  "ops.al.fired": "Fired {count} times, last {at}",
  "ops.al.neverFired": "Has not fired yet",
  "ops.al.saved": "Alert «{name}» saved",
  "ops.al.err.name": "Name the alert",
  "ops.al.err.value": "Set the threshold",
  "ops.al.err.number": "The threshold is a number",
  "ops.al.delete.title": "Delete the alert «{name}»?",
};
